var _path, _rect, _rect2, _rect3, _rect4, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#doc_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 3,
    x: 15,
    y: 24,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3,
    x: 15,
    y: 30,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18.75,
    height: 3,
    x: 15,
    y: 36,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#130E99",
    rx: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.967 18H6.658v-6h2.285q.925 0 1.6.36a2.5 2.5 0 0 1 1.043 1.032q.369.67.369 1.608t-.366 1.611q-.366.671-1.037 1.032Q9.88 18 8.967 18m-.68-1.383h.621q.446 0 .759-.143a.97.97 0 0 0 .48-.495q.168-.352.167-.979 0-.627-.17-.979a.97.97 0 0 0-.492-.495 1.9 1.9 0 0 0-.79-.143h-.575zM18.521 15q0 1.002-.39 1.69-.39.686-1.051 1.04a3.1 3.1 0 0 1-1.477.352 3.1 3.1 0 0 1-1.482-.355 2.64 2.64 0 0 1-1.05-1.042q-.386-.689-.386-1.685 0-1.002.387-1.687.39-.69 1.049-1.04a3.1 3.1 0 0 1 1.482-.355q.814 0 1.477.355a2.6 2.6 0 0 1 1.052 1.04q.39.685.39 1.687m-1.676 0q0-.54-.143-.908a1.15 1.15 0 0 0-.42-.563 1.15 1.15 0 0 0-.679-.193q-.405 0-.682.193a1.17 1.17 0 0 0-.42.563q-.14.37-.14.908 0 .54.14.911.144.37.42.563.278.19.682.19.405 0 .68-.19.278-.194.419-.563.143-.372.143-.911m8.031-.75h-1.652a1.1 1.1 0 0 0-.094-.372.8.8 0 0 0-.205-.287.9.9 0 0 0-.313-.188 1.2 1.2 0 0 0-.42-.067q-.41 0-.694.2-.281.198-.427.57a2.5 2.5 0 0 0-.144.894q0 .55.147.923.15.37.43.557.282.184.677.184.225 0 .404-.056a1 1 0 0 0 .31-.167.9.9 0 0 0 .215-.26q.085-.156.114-.349l1.652.012a2.2 2.2 0 0 1-.213.776 2.5 2.5 0 0 1-.525.727q-.337.33-.835.533a3.1 3.1 0 0 1-1.157.202q-.825 0-1.483-.355a2.57 2.57 0 0 1-1.034-1.042q-.378-.689-.378-1.685 0-1.002.387-1.687a2.6 2.6 0 0 1 1.043-1.04 3.03 3.03 0 0 1 1.465-.355q.568 0 1.046.155.477.156.838.454.36.296.58.73.22.433.266.993"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "doc_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgDoc;